import { render } from "./AtomSpinner.vue?vue&type=template&id=6f21bc9c&scoped=true"
import script from "./AtomSpinner.vue?vue&type=script&lang=js"
export * from "./AtomSpinner.vue?vue&type=script&lang=js"

import "./AtomSpinner.vue?vue&type=style&index=0&id=6f21bc9c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f21bc9c"]])

export default __exports__